import React, { ComponentProps } from 'react'

import { B2, B5, Icon, Pressable, Stack, XStack } from '@zet/design-system'
import { styled } from 'nativewind'

const ToastContainer = styled(
  XStack,
  ' rounded border-l-4 bg-white p-[12px] elevation-md w-full',
  {
    variants: {
      intent: {
        error: 'border-l-error-100',
        success: 'border-l-success-100 ',
        warning: 'border-l-warning-100',
      },
    },
    defaultProps: {
      intent: 'success',
    },
  }
)

type ToastFrameProps = ComponentProps<typeof ToastContainer>

type ToastProps = ToastFrameProps & {
  messageHeading: string
  messageDescription: string
  onClosePress?: () => void
  action?: {
    text: string
    onPress?: () => void
  }
}

const ToasterLogoContainer = styled(XStack, 'flex-grow')
const SingleSidedShadowBox = styled(
  Stack,
  'overflow-hidden p-[1px] rounded-2xl bg-[#FFF1F0] px-3 py-2'
)

const MessageContainer = styled(Stack, 'ml-2.5 mr-2 flex flex-1')
const MessageIcon = styled(Icon, '')
const MessageHeading = styled(B2, ' text-grays-80 ')
const MessageDescription = styled(B5, ' text-xs text-[#3E0006]')

const JfsContainer = ({
  messageDescription,
  messageHeading,
  action,
  onClosePress,
  ...props
}: ToastProps) => {
  return (
    <SingleSidedShadowBox {...props}>
      <ToasterLogoContainer style={{ flex: 1 }}>
        <MessageIcon
          fill="red"
          type={'CircleCloseFilled'}
          color={'red'}
          size={20}
        />
        <MessageContainer>
          <MessageHeading
            style={{
              fontWeight: messageDescription ? '800' : '600',
            }}
          >
            {messageHeading}
          </MessageHeading>
          {messageDescription && (
            <MessageDescription>{messageDescription}</MessageDescription>
          )}
        </MessageContainer>
        <Pressable
          onPress={action ? action?.onPress ?? (() => null) : onClosePress}
        >
          <MessageIcon type={'Close'} color={'red'} size={24} />
        </Pressable>
      </ToasterLogoContainer>
    </SingleSidedShadowBox>
  )
}

export default JfsContainer
